import React from "react";
import { Button, buttonVariants } from "../../components/ui/button";
import { VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";

interface LoadingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  loading?: boolean;
  svgProps?: React.SVGProps<SVGSVGElement>;
}

export const LoadingButton = React.forwardRef<
  HTMLButtonElement,
  LoadingButtonProps
>(({ children, loading, type, variant, className, size, ...rest }, ref) => {
  return (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      type={type ?? "button"}
      disabled={loading || rest.disabled}
      className={className}
      {...rest}
    >
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Button>
  );
});

LoadingButton.displayName = "LoadingButton";
